export const NUMERIC_FIELD_TYPES = ['budget', 'number', 'currency', 'calc'];
export const CURRENCY_FIELD_TYPES = ['budget', 'currency'];
// export const OTHER_FIELD_TYPES = ['text' | 'reminder' | 'url' | 'phone' | 'email' | 'location' | 'checkbox' | 'date']

export const computeFieldValue = (fieldId, { resourceFields, allFields, trackedTime }) => {
    const field = allFields.find(field => field.id === fieldId);
    const taskField = resourceFields.find(field => field.id === fieldId);

    switch (field?.type) {
        case 'budget':
            if (field.tracking_type === 'manual') {
                return (taskField?.value || 0) * field.cost_per_hour;
            }

            return trackedTime / 1000 / 60 / 60 * field.cost_per_hour;

        case 'calc':
            let result  = 0;

            if (Array.isArray(field?.expression)) {
                field.expression.forEach(entry => {
                    const computedValue = computeFieldValue(entry.fieldId, { resourceFields, allFields, trackedTime });
                    const fieldValue = (computedValue === '' || typeof computedValue === 'undefined') ? 0 : Number(computedValue);

                    switch (entry.operator) {
                        case 'add':
                            result += fieldValue;
                            break;

                        case 'subtract':
                            result -= fieldValue;
                            break;

                        case 'divide':
                            result /= fieldValue;
                            break;

                        case 'multiply':
                            result *= fieldValue;
                            break;

                        default:
                            // eslint
                    }
                });
            }

            return result;

        default:
            return taskField?.value;
    }
}

